const getStyles = () => {
  return {
    staticHero: {
      background:
        'linear-gradient(286.02deg, #080A14 38.02%, #10121E 61.92%, #282A34 74.32%, #404354 90.71%, #343643 99.65%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      clear: 'both',
      '@media (max-width: 768px)': {
        minHeight: '100vh',
        padding: '60px 0'
      }
    },
    heroContainer: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: '0',
      top: '0',
      opacity: '0.1',
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    },
    heroInner: {
      width: '100%',
      height: '100%',
      position: 'relative',
      zIndex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left'
    },
    heroContent: {
      padding: '0px 20px',
      '@media (max-width: 768px)': {
        padding: '0px 50px',
        textAlign: 'center'
      }
    },
    textGradient: {
      background: 'linear-gradient(135deg, #6a62ffff 0%, #0daef3ff 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent'
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 20px',
      marginBottom: '30px',
      borderRadius: '50px',
      background: 'rgb(255 255 255)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(58, 142, 246, 0.3)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
      color: '#4f46e5'
    },
    slideTitleh1: {
      fontWeight: '700',
      fontSize: '44px',
      lineHeight: '1.2',
      margin: '0 0 24px 0',
      color: '#FFFFFF',
      textTransform: 'none',
      '@media (max-width: 768px)': {
        fontSize: '35px',
        textAlign: 'center'
      }
    },
    slideTextp: {
      fontSize: '20px',
      lineHeight: '1.6',
      marginBottom: '32px',
      color: 'rgba(255,255,255,0.9)',
      textAlign: 'left',
      '@media (max-width: 768px)': {
        textAlign: 'center'
      }
    },
    buttonGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      marginTop: '16px',
      '@media (max-width: 768px)': {
        justifyContent: 'center'
      }
    },
    themeBtn: {
      color: '#fff',
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: '500',
      padding: '16px 32px',
      textTransform: 'none',
      fontSize: '18px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      borderRadius: '8px',
      border: 'none',
      transition: 'all 0.3s ease-in-out',
      boxShadow: '0 4px 15px rgba(150, 180, 220, 0.3)',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 25px rgba(150, 180, 220, 0.4)'
      },
      '@media (max-width: 768px)': {
        fontSize: '16px',
        padding: '12px 24px'
      },
      '@media (max-width: 425px)': {
        padding: '0px'
      }
    },
    outlineBtn: {
      color: '#FFFFFF',
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: '500',
      padding: '16px 32px',
      textTransform: 'none',
      fontSize: '18px',
      background: 'rgba(255,255,255,0.1)',
      border: '1px solid #FFFFFF',
      borderRadius: '8px',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        backgroundColor: '#FFFFFF',
        color: '#4f46e5'
      },
      '@media (max-width: 768px)': {
        fontSize: '16px',
        padding: '12px 24px'
      }
    },
    heroImageContainer: {
      position: 'relative',
      animation: 'scaleIn 0.8s ease-out'
    },
    heroImageGlow: {
      position: 'absolute',
      inset: '-16px',
      backgroundColor: 'rgba(212, 175, 55, 0.2)',
      borderRadius: '24px',
      filter: 'blur(16px)',
      zIndex: '0'
    },
    heroImage: {
      position: 'relative',
      borderRadius: '16px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
      width: '100%',
      height: 'auto',
      zIndex: '1'
    },
    scrollIndicator: {
      position: 'absolute',
      bottom: '40px',
      left: '50%',
      transform: 'translateX(-50%)',
      animation: 'bounce 2s infinite'
    },
    scrollCircle: {
      width: '24px',
      height: '40px',
      border: '2px solid rgba(255,255,255,0.5)',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: '8px'
    },
    scrollDot: {
      width: '4px',
      height: '12px',
      backgroundColor: 'rgba(255,255,255,0.5)',
      borderRadius: '2px'
    }
  };
};

export default getStyles;
